// Load jQuery
import $ from 'jquery';
window.$ = window.jQuery = $;

jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.wheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("wheel", handle, { passive: true });
    }
};
jQuery.event.special.mousewheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};

//Load Libraries
require('magnific-popup/dist/jquery.magnific-popup.min');

//Load Modules
require('./modules/accordion');
require('./modules/bannerVideo');
require('./modules/formInputs');
require('./modules/videoButtonReplacer');
require('./modules/videoPopup');
require('./modules/menu');
require('./modules/searchToggle');
require('./modules/slider--links');
require('./modules/slider--articles');
require('./modules/slider--services');
require('./modules/slider--timeline');
require('./modules/slider--team');
require('./modules/tabs');
